<p-dialog header="{{vendorHeader}}" [(visible)]="displayVendorAdd" [modal]="true" [closable]="false" [responsive]="true"
  [style]="{width: '60vw'}" styleClass="add-edit-account" (onHide)="resetDialog()">

  <form [formGroup]="vendorForm">
    <div class="header">
      <h5>Vendor Information
        <span *ngIf="isView" style="float: right;cursor: pointer;padding: 5px;" (click)="enableVendorForm()"
          class="pi pi-pencil"></span>
        <p-inputSwitch class="header-switch" formControlName="statusId"></p-inputSwitch>
      </h5>
    </div>
    <div class="card">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12">
          <label>{{vendorTemplate && vendorTemplate.labels_vendor && vendorTemplate.labels_vendor[0]?.labelname}}
            <span style="color: red;">*</span></label>
          <input pInputText type="text" formControlName="vendorName" id="name" name="name" />
          <small
            *ngIf="vendorForm.get('vendorName').invalid && (vendorForm.get('vendorName').touched || vendorForm.get('vendorName').dirty)"
            class="p-invalid">
            Name is required</small>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_vendor && vendorTemplate.labels_vendor[1]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_vendor &&
            vendorTemplate.labels_vendor[1]?.labelname}}</label>
         
          <p-multiSelect [options]="vendorTypes" placeholder="Select Vendor Type" appendTo="body" optionLabel="name"
            optionValue="id" formControlName="vendorTypeId" [filter]="true">
          </p-multiSelect>
        </div>
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_vendor && vendorTemplate.labels_vendor[2]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_vendor &&
            vendorTemplate.labels_vendor[2]?.labelname}}</label>
          <input pInputText type="text" id="number" name="number" formControlName="accountNumber" />
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_vendor && vendorTemplate.labels_vendor[3]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_vendor &&
            vendorTemplate.labels_vendor[3]?.labelname}}</label>
          <input pInputText type="text" formControlName="emailAddress" id="number" name="number" />
          <small
            *ngIf="vendorForm.get('emailAddress').invalid && (vendorForm.get('emailAddress').touched || vendorForm.get('emailAddress').dirty)"
            class="p-invalid">
            Invalid Email</small>
        </div>
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_vendor && vendorTemplate.labels_vendor[4]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_vendor &&
            vendorTemplate.labels_vendor[4]?.labelname}}</label>
          <span class="p-input-icon-left" style="width: 100%; position: relative;">
            <i pTooltip="Phone" tooltipPosition="top" class="pi pi-mobile"></i>
            <input pInputText type="text" id="number" name="number" formControlName="phoneNumber" />
          </span>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_vendor && vendorTemplate.labels_vendor[5]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_vendor &&
            vendorTemplate.labels_vendor[5]?.labelname}}</label>
          <p-dropdown [options]="timeZoneList" placeholder="Select Time Zone" appendTo="body"
            formControlName="timeZoneId" [showClear]="true" [filter]="true" optionLabel="name"
            optionValue="id"></p-dropdown>
        </div>
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_vendor && vendorTemplate.labels_vendor[6]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_vendor &&
            vendorTemplate.labels_vendor[6]?.labelname}}</label>
          <p-dropdown [options]="currencyList" id="currency" optionLabel="name" placeholder="Select currency"
            appendTo="body" inputId="currency" formControlName="currencyId" [showClear]="true" [filter]="true"
            optionValue="id">
            <ng-template let-item pTemplate="selectedItem">
              {{item.name}} - {{item.code}}
            </ng-template>
            <ng-template let-obj pTemplate="item">
              {{obj.name}} - {{obj.code}}
            </ng-template>
          </p-dropdown>
        </div>
      </div>
      <!-- Custom -->
      <div class="p-field p-formgrid p-grid">
        <ng-container *ngFor="let field of vendor_information; let i=index;">
          <ng-container [ngSwitch]="field.formControl.name">
            <ng-container *ngSwitchCase="'InputBox'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_information)">*</span></label>
                <input pInputText type="text" [disabled]="isView" name="input-{{i}}" #input="ngModel"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'DropDownList'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_information)">*</span></label>
                <p-dropdown [options]="field.pickListValues" [id]="'cf_info'+i" [disabled]="isView" [name]="'cf_info'+i"
                  [placeholder]="'Select ' +field.name" appendTo="body" optionLabel="name" [showClear]="true"
                  [filter]="true" dataKey="name" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDropdown' : ''"></p-dropdown>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'MultipleDropDownList'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_information)">*</span></label>
                <p-multiSelect [options]="field.pickListValues" [id]="'cf_info'+i" [name]="'cf_info'+i"
                  [placeholder]="'Select ' +field.name" [disabled]="isView" appendTo="body" optionLabel="name"
                  dataKey="name" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customMultiSelect' : ''">
                </p-multiSelect>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'CheckBox'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_information)">*</span></label>
                <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                  <p-checkbox [name]="'cf_chkbx'+i" [disabled]="isView" [value]="opt.name" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customCheckbox' : ''">
                  </p-checkbox> {{opt.name}}
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'FileUpload'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_information)">*</span></label>
                <p-fileUpload #refFile [disabled]="isView" name="myfile[]" customUpload="true"
                  (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                  maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                  <ng-template pTemplate="content">
                    <ul *ngIf="field.customUploadedFiles.length">
                      <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                        {{file.name}} - {{file.size}} bytes
                        <button icon="pi pi-times" pButton type="button" *ngIf="!isView"
                          (click)="deleteFile(field,index)" icon="pi pi-times"></button>
                      </li>
                    </ul>
                  </ng-template>
                </p-fileUpload>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Picture'">
              <div class="p-col-12 p-lg-4 p-mt-2 p-mb-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_information)">*</span></label>
                <p-fileUpload #refFile [disabled]="isView" name="myfile[]" customUpload="true"
                  (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                  maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                  <ng-template pTemplate="content">
                    <ul *ngIf="field.customUploadedFiles.length">
                      <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                        {{file.name}} - {{file.size}} bytes
                        <button icon="pi pi-times" pButton type="button" *ngIf="!isView"
                          (click)="deleteFile(field,index)" icon="pi pi-times"></button>
                      </li>
                    </ul>
                  </ng-template>
                </p-fileUpload>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'RadioButton'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_information)">*</span></label>
                <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                  <p-radioButton [disabled]="isView" [name]="'cf_rdo'+i" [value]="opt.name" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRadioButton' : ''">
                  </p-radioButton>&nbsp;{{opt.name}}
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Rating'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_information)">*</span></label>
                <p-rating [cancel]="false" [disabled]="isView" [(ngModel)]="field.value"
                  [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRating' : ''"></p-rating>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'ToggleButton'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2" style="width:60%"><span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_information)">*</span></label>
                <p-toggleButton class="p-mb-2" onLabel="{{field.labelname}}" [ngModelOptions]="{standalone: true}"
                  offLabel="{{field.labelname}}" [onIcon]="'pi pi-check'" (onChange)="setTogleValue(field,$event)"
                  [offIcon]="'pi pi-times'" iconPos="right" [disabled]="isView" [(ngModel)]="field.value">
                </p-toggleButton>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2" style="width:60%">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_information)">*</span></label>
                <p-calendar [disabled]="isView" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  appendTo="body"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDatePicker' : ''"></p-calendar>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Decimal'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_information)">*</span></label>
                <p-inputNumber [(ngModel)]="field.value" [minFractionDigits]="0"
                  [maxFractionDigits]="(field?.maxLengthAfterDecimal||6)"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDecimal' : ''"
                  [ngModelOptions]="{standalone: true}" (keypress)="utility.isNumberKey($event)">
                </p-inputNumber>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_information)">*</span></label>
                <input pInputText type="text" (keypress)="utility.isNumberKey($event)"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" />
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_information)">*</span></label>
                <input [disabled]="isView" pInputText type="text" [(ngModel)]="field.value"
                  [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="header" *ngIf="showAccountInfoMore">
      <h5>Business Details</h5>
    </div>
    <div class="card" *ngIf="showAccountInfoMore">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_businessdetails && vendorTemplate.labels_businessdetails[0]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_businessdetails &&
            vendorTemplate.labels_businessdetails[0]?.labelname}}</label>
          <input pInputText type="text" id="number" formControlName="doingBusinessAs" name="number" />
        </div>
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_businessdetails && vendorTemplate.labels_businessdetails[1]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_businessdetails &&
            vendorTemplate.labels_businessdetails[1]?.labelname}}</label>
          <input pInputText type="text" id="number" formControlName="taxId" name="number" />
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_businessdetails && vendorTemplate.labels_businessdetails[2]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_businessdetails &&
            vendorTemplate.labels_businessdetails[2]?.labelname}}</label>
          <p-dropdown [options]="employeesCount" name="employeesRange" placeholder="Select Employee" appendTo="body"
            inputId="employeesRange" [showClear]="true" [filter]="true" optionLabel="name"
            formControlName="employeesRangeId" optionValue="id"></p-dropdown>
        </div>
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_businessdetails && vendorTemplate.labels_businessdetails[3]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_businessdetails &&
            vendorTemplate.labels_businessdetails[3]?.labelname}}</label>
          <p-dropdown [options]="annualRevenue" placeholder="Select Revenue" name="annualRevenue" appendTo="body"
            inputId="annualRevenue" [showClear]="true" [filter]="true" formControlName="annualRevenueId"
            optionLabel="name" optionValue="id"></p-dropdown>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_businessdetails && vendorTemplate.labels_businessdetails[4]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_businessdetails &&
            vendorTemplate.labels_businessdetails[4]?.labelname}}</label>
          <p-dropdown [options]="owners" name="ownerShipType" placeholder="Select ownership" appendTo="body"
            inputId="ownership" [showClear]="true" [filter]="true" formControlName="ownershipId" optionLabel="name"
            optionValue="id" [filter]="true"></p-dropdown>
        </div>
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_businessdetails && vendorTemplate.labels_businessdetails[5]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_businessdetails &&
            vendorTemplate.labels_businessdetails[5]?.labelname}}</label>
          <p-dropdown [options]="businessClass" name="businessClassification" formControlName="businessClassificationId"
            appendTo="body" placeholder="Select account category" [showClear]="true" [filter]="true"
            inputId="businessClassification" optionLabel="name" optionValue="id"></p-dropdown>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_businessdetails && vendorTemplate.labels_businessdetails[6]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_businessdetails &&
            vendorTemplate.labels_businessdetails[6]?.labelname}}</label>
          <input pInputText type="text" formControlName="foundedYear" id="number" name="number" />
        </div>
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_businessdetails && vendorTemplate.labels_businessdetails[7]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_businessdetails &&
            vendorTemplate.labels_businessdetails[7]?.labelname}}</label>
          <p-dropdown [options]="industryList" placeholder="Select Industry" formControlName="industryId"
            appendTo="body" optionLabel="name" name="industry" [showClear]="true" [filter]="true" optionValue="id"
            inputId="industry"></p-dropdown>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_businessdetails && vendorTemplate.labels_businessdetails[8]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_businessdetails &&
            vendorTemplate.labels_businessdetails[8]?.labelname}}</label>
          <input pInputText type="text" id="number" name="number" formControlName="sicCode" />
        </div>
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_businessdetails && vendorTemplate.labels_businessdetails[9]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_businessdetails &&
            vendorTemplate.labels_businessdetails[9]?.labelname}}</label>
          <input pInputText type="text" id="number" name="number" formControlName="naicsCode" />
        </div>
      </div>
      <!-- Custom -->
      <div class="p-field p-formgrid p-grid">
        <ng-container *ngFor="let field of vendor_business; let i=index;">
          <ng-container [ngSwitch]="field.formControl.name">
            <ng-container *ngSwitchCase="'InputBox'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_business)">*</span></label>
                <input [disabled]="isView" pInputText type="text" name="input-{{i}}" #input="ngModel"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'DropDownList'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_business)">*</span></label>
                <p-dropdown [disabled]="isView" [options]="field.pickListValues" [id]="'cf_info'+i" appendTo="body"
                  [name]="'cf_info'+i" [placeholder]="'Select ' +field.name" [showClear]="true" [filter]="true"
                  optionLabel="name" dataKey="name" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDropdown' : ''"></p-dropdown>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'MultipleDropDownList'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_business)">*</span></label>
                <p-multiSelect [options]="field.pickListValues" [id]="'cf_info'+i" appendTo="body" [name]="'cf_info'+i"
                  [placeholder]="'Select ' +field.name" [disabled]="isView" optionLabel="name" dataKey="name"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customMultiSelect' : ''">
                </p-multiSelect>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'CheckBox'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_business)">*</span></label>
                <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                  <p-checkbox [name]="'cf_chkbx'+i" [disabled]="isView" [value]="opt.name" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customCheckbox' : ''">
                  </p-checkbox> {{opt.name}}
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'FileUpload'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_business)">*</span></label>
                <p-fileUpload #refFile [disabled]="isView" name="myfile[]" customUpload="true"
                  (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                  maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                  <ng-template pTemplate="content">
                    <ul *ngIf="field.customUploadedFiles.length">
                      <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                        {{file.name}} - {{file.size}} bytes
                        <button icon="pi pi-times" pButton type="button" *ngIf="!isView"
                          (click)="deleteFile(field,index)" icon="pi pi-times"></button>
                      </li>
                    </ul>
                  </ng-template>
                </p-fileUpload>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Picture'">
              <div class="p-col-12 p-lg-4 p-mt-2 p-mb-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_business)">*</span></label>
                <p-fileUpload #refFile [disabled]="isView" name="myfile[]" customUpload="true"
                  (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                  maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                  <ng-template pTemplate="content">
                    <ul *ngIf="field.customUploadedFiles.length">
                      <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                        {{file.name}} - {{file.size}} bytes
                        <button icon="pi pi-times" pButton type="button" *ngIf="!isView"
                          (click)="deleteFile(field,index)" icon="pi pi-times"></button>
                      </li>
                    </ul>
                  </ng-template>
                </p-fileUpload>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'RadioButton'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_business)">*</span></label>
                <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                  <p-radioButton [disabled]="isView" [name]="'cf_rdo'+i" [value]="opt.name" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRadioButton' : ''">
                  </p-radioButton>&nbsp;{{opt.name}}
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Rating'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_business)">*</span></label>
                <p-rating [cancel]="false" [disabled]="isView" [(ngModel)]="field.value"
                  [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRating' : ''"></p-rating>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'ToggleButton'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2" style="width:60%"><span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_business)">*</span></label>
                <p-toggleButton class="p-mb-2" onLabel="{{field.labelname}}" (onChange)="setTogleValue(field,$event)"
                  offLabel="{{field.labelname}}" [onIcon]="'pi pi-check'" [disabled]="isView"
                  [ngModelOptions]="{standalone: true}" [offIcon]="'pi pi-times'" iconPos="right"
                  [(ngModel)]="field.value">
                </p-toggleButton>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2" style="width:60%">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_business)">*</span></label>
                <p-calendar [disabled]="isView" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  appendTo="body"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDatePicker' : ''"></p-calendar>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Decimal'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_business)">*</span></label>
                <p-inputNumber [(ngModel)]="field.value" [minFractionDigits]="0"
                  [maxFractionDigits]="(field?.maxLengthAfterDecimal||6)"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDecimal' : ''"
                  [ngModelOptions]="{standalone: true}" (keypress)="utility.isNumberKey($event)">
                </p-inputNumber>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_business)">*</span></label>
                <input pInputText type="text" (keypress)="utility.isNumberKey($event)"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" />
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_business)">*</span></label>
                <input pInputText type="text" [disabled]="isView" [(ngModel)]="field.value"
                  [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="header" *ngIf="showAccountInfoMore">
      <h5>Payment Details</h5>
    </div>
    <div class="card" *ngIf="showAccountInfoMore">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12"
          [ngClass]="{'p-md-6': vendorForm.controls['paymentMethodId']?.value?.length == 0, 'p-md-3' : vendorForm.controls['paymentMethodId']?.value?.length > 0 }"
          *ngIf="vendorTemplate && vendorTemplate.labels_paymentdetails && vendorTemplate.labels_paymentdetails[0]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_paymentdetails &&
            vendorTemplate.labels_paymentdetails[0]?.labelname}}</label>
          <p-multiSelect [options]="allPaymentMethodsDD" placeholder="Select Payment Method" optionLabel="name"
            appendTo="body" formControlName="paymentMethodId"></p-multiSelect>
        </div>
        <div class="p-col-12 p-md-3" *ngIf="vendorForm.controls['paymentMethodId']?.value?.length > 0">
          <label>Perferred Payment Method</label>
          <p-dropdown [options]="vendorForm.controls['paymentMethodId']?.value" placeholder="Perferred Payment Method"
            optionLabel="name" optionValue="id" appendTo="body" formControlName="preferredPaymentMethodId"></p-dropdown>
        </div>
   
        <div class="p-col-12"
          [ngClass]="{'p-md-6': vendorForm.controls['paymentTermId']?.value?.length == 0, 'p-md-3' : vendorForm.controls['paymentTermId']?.value?.length > 0 }"
          *ngIf="vendorTemplate && vendorTemplate.labels_paymentdetails && vendorTemplate.labels_paymentdetails[1]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_paymentdetails &&
            vendorTemplate.labels_paymentdetails[1]?.labelname}}</label>
          <p-multiSelect [options]="allPaymentTermsDD" placeholder="Select Payment Term" optionLabel="name"
            appendTo="body" formControlName="paymentTermId"></p-multiSelect>
        </div>
        <div class="p-col-12 p-md-3" *ngIf="vendorForm.controls['paymentTermId']?.value?.length > 0">
          <label>Perferred Payment Term</label>
          <p-dropdown [options]="vendorForm.controls['paymentTermId']?.value" placeholder="Perferred Payment Term"
            optionLabel="name" optionValue="id" appendTo="body" formControlName="preferredPaymentTermId"></p-dropdown>
        </div>
     
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12"
          [ngClass]="{'p-md-6': vendorForm.controls['shippingMethodId']?.value?.length == 0, 'p-md-3' : vendorForm.controls['shippingMethodId']?.value?.length > 0 }"
          *ngIf="vendorTemplate && vendorTemplate.labels_paymentdetails && vendorTemplate.labels_paymentdetails[2]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_paymentdetails &&
            vendorTemplate.labels_paymentdetails[2]?.labelname}}</label>
          <p-multiSelect [options]="allShippingMethodDD" placeholder="Select Shipping Method" optionLabel="name"
            appendTo="body" formControlName="shippingMethodId"></p-multiSelect>
        </div>
        <div class="p-col-12 p-md-3" *ngIf="vendorForm.controls['shippingMethodId']?.value?.length > 0">
          <label>Perferred Shipping Method</label>
          <p-dropdown [options]="vendorForm.controls['shippingMethodId']?.value" placeholder="Perferred Shipping Method"
            optionLabel="name" appendTo="body" optionValue="id"
            formControlName="preferredShippingMethodId"></p-dropdown>
        </div>
      </div>
      <!-- Custom -->
      <div class="p-field p-formgrid p-grid">
        <ng-container *ngFor="let field of vendor_payment; let i=index;">
          <ng-container [ngSwitch]="field.formControl.name">
            <ng-container *ngSwitchCase="'InputBox'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_payment)">*</span></label>
                <input [disabled]="isView" pInputText type="text" name="input-{{i}}" #input="ngModel"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'DropDownList'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_payment)">*</span></label>
                <p-dropdown [disabled]="isView" [options]="field.pickListValues" [id]="'cf_info'+i" appendTo="body"
                  [name]="'cf_info'+i" [placeholder]="'Select ' +field.name" [showClear]="true" [filter]="true"
                  optionLabel="name" dataKey="name" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDropdown' : ''"></p-dropdown>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'MultipleDropDownList'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_payment)">*</span></label>
                <p-multiSelect [options]="field.pickListValues" [id]="'cf_info'+i" appendTo="body" [name]="'cf_info'+i"
                  [disabled]="isView" [placeholder]="'Select ' +field.name" optionLabel="name" dataKey="name"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customMultiSelect' : ''">
                </p-multiSelect>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'CheckBox'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_payment)">*</span></label>
                <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                  <p-checkbox [name]="'cf_chkbx'+i" [disabled]="isView" [value]="opt.name" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customCheckbox' : ''">
                  </p-checkbox> {{opt.name}}
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'FileUpload'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_payment)">*</span></label>
                <p-fileUpload #refFile [disabled]="isView" name="myfile[]" customUpload="true"
                  (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                  maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                  <ng-template pTemplate="content">
                    <ul *ngIf="field.customUploadedFiles.length">
                      <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                        {{file.name}} - {{file.size}} bytes
                        <button icon="pi pi-times" pButton type="button" *ngIf="!isView" (click)="deleteFile(field,index)"
                          icon="pi pi-times"></button>
                      </li>
                    </ul>
                  </ng-template>
                </p-fileUpload>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Picture'">
              <div class="p-col-12 p-lg-4 p-mt-2 p-mb-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_payment)">*</span></label>
                <p-fileUpload #refFile name="myfile[]" [disabled]="isView" customUpload="true"
                  (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                  maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                  <ng-template pTemplate="content">
                    <ul *ngIf="field.customUploadedFiles.length">
                      <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                        {{file.name}} - {{file.size}} bytes
                        <button icon="pi pi-times" pButton type="button" *ngIf="!isView" (click)="deleteFile(field,index)"
                          icon="pi pi-times"></button>
                      </li>
                    </ul>
                  </ng-template>
                </p-fileUpload>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'RadioButton'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_payment)">*</span></label>
                <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                  <p-radioButton [disabled]="isView" [name]="'cf_rdo'+i" [value]="opt.name" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRadioButton' : ''">
                  </p-radioButton>&nbsp;{{opt.name}}
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Rating'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_payment)">*</span></label>
                <p-rating [cancel]="false" [disabled]="isView" [(ngModel)]="field.value"
                  [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRating' : ''"></p-rating>
  
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'ToggleButton'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2" style="width:60%"><span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_payment)">*</span></label>
                <p-toggleButton class="p-mb-2" onLabel="{{field.labelname}}" (onChange)="setTogleValue(field,$event)"
                  offLabel="{{field.labelname}}" [onIcon]="'pi pi-check'" [disabled]="isView"
                  [ngModelOptions]="{standalone: true}" [offIcon]="'pi pi-times'" iconPos="right"
                  [(ngModel)]="field.value">
                </p-toggleButton>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2" style="width:60%">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_payment)">*</span></label>
                <p-calendar [disabled]="isView" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  appendTo="body"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDatePicker' : ''"></p-calendar>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Decimal'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_payment)">*</span></label>
                <p-inputNumber [(ngModel)]="field.value" [minFractionDigits]="0"
                  [maxFractionDigits]="(field?.maxLengthAfterDecimal||6)"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDecimal' : ''"
                  [ngModelOptions]="{standalone: true}" (keypress)="utility.isNumberKey($event)">
                </p-inputNumber>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_payment)">*</span></label>
                <input pInputText type="text" (keypress)="utility.isNumberKey($event)"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" />
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_payment)">*</span></label>
                <input pInputText type="text" [disabled]="isView" [(ngModel)]="field.value"
                  [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="p-field p-formgrid p-grid">
      <div class="p-col-12">
        <button type="button" style="float: right;" pButton (click)="showAccountInfoMore = !showAccountInfoMore"
          label="{{showAccountInfoMore ? 'Show Less' : 'Show More'}}" class="p-button-secondary"></button>
      </div>
    </div>

    <div class="header">
      <h5>Contact Information</h5>
    </div>
    <div class="card">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-2"
          *ngIf="vendorTemplate && vendorTemplate.labels_contact && vendorTemplate.labels_contact[0]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_contact &&
            vendorTemplate.labels_contact[0]?.labelname}}</label>
          <!-- <input pInputText type="text" formControlName="title" id="title" name="title" /> -->
          <p-dropdown [options]="salutations" [showClear]="true" [filter]="true" placeholder="Select title"
            optionLabel="name" formControlName="salutationId" appendTo="body"></p-dropdown>
        </div>
        <div class="p-col-12 p-lg-4"
          *ngIf="vendorTemplate && vendorTemplate.labels_contact && vendorTemplate.labels_contact[1]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_contact &&
            vendorTemplate.labels_contact[1]?.labelname}}</label>
          <input pInputText type="text" id="fname" formControlName="firstName" name="fname" />
        </div>
        <div class="p-col-12 p-lg-2"
          *ngIf="vendorTemplate && vendorTemplate.labels_contact && vendorTemplate.labels_contact[2]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_contact &&
            vendorTemplate.labels_contact[2]?.labelname}}</label>
          <input pInputText type="text" id="title" formControlName="middleName" name="title" />
        </div>
        <div class="p-col-12 p-lg-4"
          *ngIf="vendorTemplate && vendorTemplate.labels_contact && vendorTemplate.labels_contact[3]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_contact &&
            vendorTemplate.labels_contact[3]?.labelname}}</label>
          <input pInputText type="text" id="lname" formControlName="lastName" name="lname" />
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_contact && vendorTemplate.labels_contact[4]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_contact &&
            vendorTemplate.labels_contact[4]?.labelname}}</label>
          <span class="p-input-icon-left" style="width: 100%; position: relative;">
            <i pTooltip="Email" tooltipPosition="top" class="pi pi-envelope"></i>
            <input pInputText type="text" id="email" formControlName="contactEmail" name="email" />
            <small
              *ngIf="vendorForm.get('contactEmail').invalid && (vendorForm.get('contactEmail').touched || vendorForm.get('contactEmail').dirty)"
              class="p-invalid">
              Invalid Email</small>
          </span>
        </div>
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_contact && vendorTemplate.labels_contact[5]?.isChecked">
          <div class="p-grid">
            <label class="p-col-10">{{vendorTemplate && vendorTemplate.labels_contact &&
              vendorTemplate.labels_contact[5]?.labelname}}</label>
            <label class="p-col-2">Ext.</label>
          </div>
          <div class="p-grid p-mt-2">
            <div class="p-col-10">
              <span class="p-input-icon-left" style="width: 100%; position: relative;">
                <i pTooltip="Phone" tooltipPosition="top" class="pi pi-mobile"></i>
                <input pInputText type="text" id="number" name="number" formControlName="contactPhone" />
              </span>
            </div>
            <div class="p-col-2">
              <p-inputNumber [useGrouping]="false" maxlength="10" formControlName="extension" [min]="0"></p-inputNumber>
            </div>
          </div>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_contact && vendorTemplate.labels_contact[6]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_contact &&
            vendorTemplate.labels_contact[6]?.labelname}}</label>
          <span class="p-input-icon-left" style="width: 100%; position: relative;">
            <i pTooltip="Social Profile" tooltipPosition="top" class="pi pi-envelope"></i>
            <input pInputText type="text" formControlName="socialProfile" id="social" name="social" />
          </span>
        </div>
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_contact && vendorTemplate.labels_contact[7]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_contact &&
            vendorTemplate.labels_contact[7]?.labelname}}</label>
          <p-dropdown [options]="genders" placeholder="Select gender" [showClear]="true" [filter]="true"
            optionLabel="name" formControlName="genderId" appendTo="body"></p-dropdown>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-4"
          *ngIf="vendorTemplate && vendorTemplate.labels_contact && vendorTemplate.labels_contact[8]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_contact &&
            vendorTemplate.labels_contact[8]?.labelname}}</label>
          <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="dd/mm/yyyy"
            dateFormat="mm/dd/yy" [maxDate]="maxDate" yearRange="1900:2100" formControlName="dob"></p-calendar>
        </div>
        <div class="p-col-12 p-lg-4"
          *ngIf="vendorTemplate && vendorTemplate.labels_contact && vendorTemplate.labels_contact[9]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_contact &&
            vendorTemplate.labels_contact[9]?.labelname}}</label>
          <p-multiSelect [options]="languages" placeholder="Select Language" optionLabel="name"
            formControlName="languages" appendTo="body" resetFilterOnHide=true>
          </p-multiSelect>
        </div>
        <div class="p-col-12 p-lg-4"
          *ngIf="vendorTemplate && vendorTemplate.labels_contact && vendorTemplate.labels_contact[10]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_contact &&
            vendorTemplate.labels_contact[10]?.labelname}}</label>
          <p-multiSelect [options]="jobFunctions" placeholder="Select Job" optionLabel="name" formControlName="job"
            appendTo="body" resetFilterOnHide=true>
          </p-multiSelect>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-4"
          *ngIf="vendorTemplate && vendorTemplate.labels_contact && vendorTemplate.labels_contact[11]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_contact &&
            vendorTemplate.labels_contact[11]?.labelname}}</label>
          <p-dropdown [options]="!isAddVendor?reportsTo:[]" placeholder="Select Reports To" appendTo="body"
            optionLabel="contact.firstName" [showClear]="true" [filter]="true"
            formControlName="reportsToId"></p-dropdown>
        </div>
        <div class="p-col-12 p-lg-4"
          *ngIf="vendorTemplate && vendorTemplate.labels_contact && vendorTemplate.labels_contact[12]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_contact &&
            vendorTemplate.labels_contact[12]?.labelname}}</label>
          <p-dropdown [options]="!isAddVendor?reportsTo:[]" placeholder="Select Assistant" appendTo="body"
            optionLabel="contact.firstName" [showClear]="true" [filter]="true"
            formControlName="assistantId"></p-dropdown>
        </div>
        <div class="p-col-12 p-lg-4"
          *ngIf="vendorTemplate && vendorTemplate.labels_contact && vendorTemplate.labels_contact[13]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_contact &&
            vendorTemplate.labels_contact[13]?.labelname}}</label>
          <span class="p-input-icon-left" style="width: 100%; position: relative;">
            <i pTooltip="Phone" tooltipPosition="top" class="pi pi-mobile"></i>
            <input pInputText type="text" id="number" name="number" formControlName="assistantPhone" />
          </span>
        </div>
      </div>
      <!-- Custom -->
      <div class="p-field p-formgrid p-grid">
        <ng-container *ngFor="let field of vendor_contact; let i=index;">
          <ng-container [ngSwitch]="field.formControl.name">
            <ng-container *ngSwitchCase="'InputBox'">
              <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_contact)">*</span></label>
                <input pInputText type="text" [disabled]="isView" name="input-{{i}}" #input="ngModel"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'DropDownList'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_contact)">*</span></label>
                <p-dropdown [options]="field.pickListValues" [id]="'cf_info'+i" [disabled]="isView" appendTo="body"
                  [name]="'cf_info'+i" [placeholder]="'Select ' +field.name" [showClear]="true" [filter]="true"
                  optionLabel="name" dataKey="name" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDropdown' : ''"></p-dropdown>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'MultipleDropDownList'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_contact)">*</span></label>
                <p-multiSelect [options]="field.pickListValues" [id]="'cf_info'+i" appendTo="body" [name]="'cf_info'+i"
                  [placeholder]="'Select ' +field.name" [disabled]="isView" optionLabel="name" dataKey="name"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customMultiSelect' : ''">
                </p-multiSelect>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'CheckBox'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_contact)">*</span></label>
                <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                  <p-checkbox [name]="'cf_chkbx'+i" [value]="opt.name" [disabled]="isView" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customCheckbox' : ''">
                  </p-checkbox> {{opt.name}}
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'FileUpload'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_contact)">*</span></label>
                <p-fileUpload #refFile [disabled]="isView" name="myfile[]" customUpload="true"
                  (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                  maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                  <ng-template pTemplate="content">
                    <ul *ngIf="field.customUploadedFiles.length">
                      <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                        {{file.name}} - {{file.size}} bytes
                        <button icon="pi pi-times" pButton type="button" *ngIf="!isView" (click)="deleteFile(field,index)"
                          icon="pi pi-times"></button>
                      </li>
                    </ul>
                  </ng-template>
                </p-fileUpload>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Picture'">
              <div class="p-col-12 p-lg-4 p-mt-2 p-mb-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_contact)">*</span></label>
                <p-fileUpload #refFile [disabled]="isView" name="myfile[]" customUpload="true"
                  (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                  maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                  <ng-template pTemplate="content">
                    <ul *ngIf="field.customUploadedFiles.length">
                      <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                        {{file.name}} - {{file.size}} bytes
                        <button icon="pi pi-times" pButton type="button" *ngIf="!isView" (click)="deleteFile(field,index)"
                          icon="pi pi-times"></button>
                      </li>
                    </ul>
                  </ng-template>
                </p-fileUpload>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'RadioButton'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_contact)">*</span></label>
                <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                  <p-radioButton [name]="'cf_rdo'+i" [value]="opt.name" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRadioButton' : ''">
                  </p-radioButton>&nbsp;{{opt.name}}
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Rating'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_contact)">*</span></label>
                <p-rating [cancel]="false" [disabled]="isView" [(ngModel)]="field.value"
                  [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRating' : ''"></p-rating>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'ToggleButton'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2" style="width:60%"><span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_contact)">*</span></label>
                <p-toggleButton class="p-mb-2" onLabel="{{field.labelname}}" (onChange)="setTogleValue(field,$event)"
                  offLabel="{{field.labelname}}" [onIcon]="'pi pi-check'" [disabled]="isView"
                  [ngModelOptions]="{standalone: true}" [offIcon]="'pi pi-times'" iconPos="right"
                  [(ngModel)]="field.value">
                </p-toggleButton>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2" style="width:60%">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_contact)">*</span></label>
                <p-calendar [disabled]="isView" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  appendTo="body"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDatePicker' : ''"></p-calendar>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Decimal'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_contact)">*</span></label>
                <p-inputNumber [(ngModel)]="field.value" [minFractionDigits]="0"
                  [maxFractionDigits]="(field?.maxLengthAfterDecimal||6)"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDecimal' : ''"
                  [ngModelOptions]="{standalone: true}" (keypress)="utility.isNumberKey($event)">
                </p-inputNumber>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_contact)">*</span></label>
                <input pInputText type="text" (keypress)="utility.isNumberKey($event)"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" />
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_contact)">*</span></label>
                <input pInputText type="text" [disabled]="isView" [(ngModel)]="field.value"
                  [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div class="header">
      <h5>Address Information
        <span class="btnBars p-mr-0" *ngIf="!isView" style="position: relative; float: right" (click)="addNewAddress()">
          <i class="pi pi-plus"></i>
        </span>
      </h5>
    </div>
    <div class="card">
      <p-table [value]="vendorTempAddress" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="header">
          <tr>
            <th *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[0]?.isChecked">
              {{vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[0]?.labelname}}
            </th>
            <th *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[1]?.isChecked">
              {{vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[1]?.labelname}}
            </th>
            <th *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[2]?.isChecked">
              {{vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[2]?.labelname}}
            </th>
            <th *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[3]?.isChecked">
              {{vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[3]?.labelname}}
            </th>
            <th *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[4]?.isChecked">
              {{vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[4]?.labelname}}
            </th>
            <th *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[5]?.isChecked">
              {{vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[5]?.labelname}}
            </th>
            <th *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[6]?.isChecked">
              {{vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[6]?.labelname}}
            </th>
            <th *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[7]?.isChecked">
              {{vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[7]?.labelname}}
            </th>
            <th style="width: 80px">Is Active</th>
            <th style="width: 85px">Is Default</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-addressObj let-index="rowIndex">
          <tr [pSelectableRow]="addressObj" [pSelectableRowIndex]="rowIndex">
            <td class="pointer" (click)="editAddress(addressObj, index)"
              *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[0]?.isChecked">
              {{ addressObj.addressType?.name }}
            </td>
            <td *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[1]?.isChecked">
              {{ addressObj?.formattedAddress }}</td>
            <td *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[2]?.isChecked">
              {{ addressObj?.streetAddress2 }}</td>
            <td *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[3]?.isChecked">
              {{ addressObj?.cityId?.name }}</td>
            <td *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[4]?.isChecked">
              {{ addressObj?.stateId?.name }}</td>
            <td *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[5]?.isChecked">
              {{ addressObj?.countryId?.name }}</td>
            <td *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[6]?.isChecked">
              {{ addressObj?.zipCode }}</td>
            <td *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[7]?.isChecked">
              {{ getContactName(addressObj) }}</td>
            <td class="action p-text-center">
              <p-inputSwitch class="header-switch" [disabled]="isView  || addressForm.controls['isDefault'].value"
                [readonly]="addressObj.isDefault" [ngModelOptions]="{standalone: true}"
                [(ngModel)]="addressObj.statusId"></p-inputSwitch>
            </td>
            <td class="action p-text-center">
              <p-radioButton [value]="true" [disabled]="isView" [(ngModel)]="addressObj.isDefault"
                [ngModelOptions]="{standalone: true}" (onClick)="setDefaultAddr(addressObj, index)">
              </p-radioButton>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="header" *ngIf="vendor_other1.length>0 && showAccountInfoMore">
      <h5>Other1</h5>
    </div>
    <div class="card" *ngIf="vendor_other1.length>0 && showAccountInfoMore">
      <!-- Custom -->
      <div class="p-field p-formgrid p-grid">
        <ng-container *ngFor="let field of vendor_other1; let i=index;">
          <ng-container [ngSwitch]="field.formControl.name">
            <ng-container *ngSwitchCase="'InputBox'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other1)">*</span></label>
                <input [disabled]="isView" pInputText type="text" name="input-{{i}}" #input="ngModel"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'DropDownList'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other1)">*</span></label>
                <p-dropdown [disabled]="isView" [options]="field.pickListValues" [id]="'cf_info'+i" [name]="'cf_info'+i"
                  [placeholder]="'Select ' +field.name" appendTo="body" optionLabel="name" dataKey="name"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDropdown' : ''"></p-dropdown>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'MultipleDropDownList'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other1)">*</span></label>
                <p-multiSelect [disabled]="isView" [options]="field.pickListValues" [id]="'cf_info'+i"
                  [name]="'cf_info'+i" [placeholder]="'Select ' +field.name" appendTo="body" optionLabel="name"
                  dataKey="name" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customMultiSelect' : ''">
                </p-multiSelect>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'CheckBox'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other1)">*</span></label>
                <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                  <p-checkbox [disabled]="isView" [name]="'cf_chkbx'+i" [value]="opt.name" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customCheckbox' : ''">
                  </p-checkbox> {{opt.name}}
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'FileUpload'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other1)">*</span></label>
                <p-fileUpload #refFile [disabled]="isView" name="myfile[]" customUpload="true"
                  (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                  maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                  <ng-template pTemplate="content">
                    <ul *ngIf="field.customUploadedFiles.length">
                      <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                        {{file.name}} - {{file.size}} bytes
                        <button icon="pi pi-times" pButton type="button" *ngIf="!isView"
                          (click)="deleteFile(field,index)" icon="pi pi-times"></button>
                      </li>
                    </ul>
                  </ng-template>
                </p-fileUpload>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Picture'">
              <div class="p-col-12 p-lg-4 p-mt-2 p-mb-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other1)">*</span></label>
                <p-fileUpload #refFile [disabled]="isView" name="myfile[]" customUpload="true"
                  (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                  maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                  <ng-template pTemplate="content">
                    <ul *ngIf="field.customUploadedFiles.length">
                      <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                        {{file.name}} - {{file.size}} bytes
                        <button icon="pi pi-times" pButton type="button" *ngIf="!isView"
                          (click)="deleteFile(field,index)" icon="pi pi-times"></button>
                      </li>
                    </ul>
                  </ng-template>
                </p-fileUpload>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'RadioButton'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other1)">*</span></label>
                <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                  <p-radioButton [disabled]="isView" [name]="'cf_rdo'+i" [value]="opt.name" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRadioButton' : ''">
                  </p-radioButton>&nbsp;{{opt.name}}
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Rating'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other1)">*</span></label>
                <p-rating [disabled]="isView" [cancel]="false" [(ngModel)]="field.value"
                  [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRating' : ''"></p-rating>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'ToggleButton'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2" style="width:60%"><span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other1)">*</span></label>
                <p-toggleButton class="p-mb-2" onLabel="{{field.labelname}}" [disabled]="isView"
                  [ngModelOptions]="{standalone: true}" offLabel="{{field.labelname}}" [onIcon]="'pi pi-check'"
                  (onChange)="setTogleValue(field,$event)" [offIcon]="'pi pi-times'" iconPos="right"
                  [(ngModel)]="field.value">
                </p-toggleButton>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2" style="width:60%">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other1)">*</span></label>
                <p-calendar [disabled]="isView" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  appendTo="body"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDatePicker' : ''"></p-calendar>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Decimal'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other1)">*</span></label>
                <p-inputNumber [(ngModel)]="field.value" [minFractionDigits]="0"
                  [maxFractionDigits]="(field?.maxLengthAfterDecimal||6)"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDecimal' : ''"
                  [ngModelOptions]="{standalone: true}" (keypress)="utility.isNumberKey($event)">
                </p-inputNumber>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other1)">*</span></label>
                <input pInputText type="text" (keypress)="utility.isNumberKey($event)"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" />
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other1)">*</span></label>
                <input pInputText [disabled]="isView" type="text" [(ngModel)]="field.value"
                  [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div class="header" *ngIf="vendor_other2.length>0 && showAccountInfoMore">
      <h5>Other2</h5>
    </div>
    <div class="card" *ngIf="vendor_other2.length>0 && showAccountInfoMore">
      <!-- Custom -->
      <div class="p-field p-formgrid p-grid">
        <ng-container *ngFor="let field of vendor_other2; let i=index;">
          <ng-container [ngSwitch]="field.formControl.name">
            <ng-container *ngSwitchCase="'InputBox'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other2)">*</span></label>
                <input [disabled]="isView" pInputText type="text" name="input-{{i}}" #input="ngModel"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'DropDownList'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other2)">*</span></label>
                <p-dropdown [options]="field.pickListValues" [id]="'cf_info'+i" [disabled]="isView" [name]="'cf_info'+i"
                  [placeholder]="'Select ' +field.name" appendTo="body" optionLabel="name" dataKey="name"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDropdown' : ''"></p-dropdown>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'MultipleDropDownList'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other2)">*</span></label>
                <p-multiSelect [options]="field.pickListValues" [id]="'cf_info'+i" [name]="'cf_info'+i"
                  [placeholder]="'Select ' +field.name" appendTo="body" optionLabel="name" [disabled]="isView"
                  dataKey="name" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customMultiSelect' : ''">
                </p-multiSelect>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'CheckBox'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other2)">*</span></label>
                <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                  <p-checkbox [disabled]="isView" [name]="'cf_chkbx'+i" [value]="opt.name" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customCheckbox' : ''">
                  </p-checkbox> {{opt.name}}
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'FileUpload'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other2)">*</span></label>
                <p-fileUpload #refFile [disabled]="isView" name="myfile[]" customUpload="true"
                  (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                  maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                  <ng-template pTemplate="content">
                    <ul *ngIf="field.customUploadedFiles.length">
                      <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                        {{file.name}} - {{file.size}} bytes
                        <button icon="pi pi-times" pButton type="button" *ngIf="!isView"
                          (click)="deleteFile(field,index)" icon="pi pi-times"></button>
                      </li>
                    </ul>
                  </ng-template>
                </p-fileUpload>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Picture'">
              <div class="p-col-12 p-lg-4 p-mt-2 p-mb-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other2)">*</span></label>
                <p-fileUpload #refFile [disabled]="isView" name="myfile[]" customUpload="true"
                  (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                  maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                  <ng-template pTemplate="content">
                    <ul *ngIf="field.customUploadedFiles.length">
                      <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                        {{file.name}} - {{file.size}} bytes
                        <button icon="pi pi-times" pButton type="button" *ngIf="!isView"
                          (click)="deleteFile(field,index)" icon="pi pi-times"></button>
                      </li>
                    </ul>
                  </ng-template>
                </p-fileUpload>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'RadioButton'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other2)">*</span></label>
                <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                  <p-radioButton [disabled]="isView" [name]="'cf_rdo'+i" [value]="opt.name" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRadioButton' : ''">
                  </p-radioButton>&nbsp;{{opt.name}}
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Rating'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other2)">*</span></label>
                <p-rating [cancel]="false" [disabled]="isView" [(ngModel)]="field.value"
                  [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRating' : ''"></p-rating>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'ToggleButton'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2" style="width:60%"><span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other2)">*</span></label>
                <p-toggleButton class="p-mb-2" onLabel="{{field.labelname}}" [ngModelOptions]="{standalone: true}"
                  offLabel="{{field.labelname}}" [onIcon]="'pi pi-check'" (onChange)="setTogleValue(field,$event)"
                  [offIcon]="'pi pi-times'" [disabled]="isView" iconPos="right" [(ngModel)]="field.value">
                </p-toggleButton>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2" style="width:60%">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other2)">*</span></label>
                <p-calendar [disabled]="isView" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  appendTo="body"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDatePicker' : ''"></p-calendar>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Decimal'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other2)">*</span></label>
                <p-inputNumber [(ngModel)]="field.value" [minFractionDigits]="0"
                  [maxFractionDigits]="(field?.maxLengthAfterDecimal||6)"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDecimal' : ''"
                  [ngModelOptions]="{standalone: true}" (keypress)="utility.isNumberKey($event)">
                </p-inputNumber>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other2)">*</span></label>
                <input pInputText type="text" (keypress)="utility.isNumberKey($event)"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" />
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other2)">*</span></label>
                <input [disabled]="isView" pInputText type="text" [(ngModel)]="field.value"
                  [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div class="header" *ngIf="vendor_other3.length>0 && showAccountInfoMore">
      <h5>Other3</h5>
    </div>
    <div class="card" *ngIf="vendor_other3.length>0 && showAccountInfoMore">
      <!-- Custom -->
      <div class="p-field p-formgrid p-grid">
        <ng-container *ngFor="let field of vendor_other3; let i=index;">
          <ng-container [ngSwitch]="field.formControl.name">
            <ng-container *ngSwitchCase="'InputBox'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other3)">*</span></label>
                <input [disabled]="isView" pInputText type="text" name="input-{{i}}" #input="ngModel"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'DropDownList'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other3)">*</span></label>
                <p-dropdown [disabled]="isView" [options]="field.pickListValues" [id]="'cf_info'+i" [name]="'cf_info'+i"
                  [placeholder]="'Select ' +field.name" appendTo="body" optionLabel="name" dataKey="name"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDropdown' : ''"></p-dropdown>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'MultipleDropDownList'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other3)">*</span></label>
                <p-multiSelect [disabled]="isView" [options]="field.pickListValues" [id]="'cf_info'+i" appendTo="body"
                  [name]="'cf_info'+i" [placeholder]="'Select ' +field.name"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customMultiSelect' : ''"
                  optionLabel="name" dataKey="name" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}">
                </p-multiSelect>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'CheckBox'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other3)">*</span></label>
                <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                  <p-checkbox [disabled]="isView" [name]="'cf_chkbx'+i" [value]="opt.name" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customCheckbox' : ''">
                  </p-checkbox> {{opt.name}}
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'FileUpload'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other3)">*</span></label>
                <p-fileUpload #refFile [disabled]="isView" name="myfile[]" customUpload="true"
                  (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                  maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                  <ng-template pTemplate="content">
                    <ul *ngIf="field.customUploadedFiles.length">
                      <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                        {{file.name}} - {{file.size}} bytes
                        <button icon="pi pi-times" pButton type="button" *ngIf="!isView"
                          (click)="deleteFile(field,index)" icon="pi pi-times"></button>
                      </li>
                    </ul>
                  </ng-template>
                </p-fileUpload>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Picture'">
              <div class="p-col-12 p-lg-4 p-mt-2 p-mb-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other3)">*</span></label>
                <p-fileUpload #refFile [disabled]="isView" name="myfile[]" customUpload="true"
                  (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                  maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                  <ng-template pTemplate="content">
                    <ul *ngIf="field.customUploadedFiles.length">
                      <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                        {{file.name}} - {{file.size}} bytes
                        <button icon="pi pi-times" pButton type="button" *ngIf="!isView"
                          (click)="deleteFile(field,index)" icon="pi pi-times"></button>
                      </li>
                    </ul>
                  </ng-template>
                </p-fileUpload>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'RadioButton'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other3)">*</span></label>
                <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                  <p-radioButton [disabled]="isView" [name]="'cf_rdo'+i" [value]="opt.name" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRadioButton' : ''">
                  </p-radioButton>&nbsp;{{opt.name}}
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Rating'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other3)">*</span></label>
                <p-rating [disabled]="isView" [cancel]="false" [(ngModel)]="field.value"
                  [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRating' : ''"></p-rating>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'ToggleButton'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2" style="width:60%"><span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other3)">*</span></label>
                <p-toggleButton class="p-mb-2" onLabel="{{field.labelname}}" [ngModelOptions]="{standalone: true}"
                  offLabel="{{field.labelname}}" [onIcon]="'pi pi-check'" (onChange)="setTogleValue(field,$event)"
                  [offIcon]="'pi pi-times'" [disabled]="isView" iconPos="right" [(ngModel)]="field.value">
                </p-toggleButton>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'DatePicker'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2" style="width:60%">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other3)">*</span></label>
                <p-calendar [disabled]="isView" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                  appendTo="body"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDatePicker' : ''"></p-calendar>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Decimal'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other3)">*</span></label>
                <p-inputNumber [(ngModel)]="field.value" [minFractionDigits]="0"
                  [maxFractionDigits]="(field?.maxLengthAfterDecimal||6)"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDecimal' : ''"
                  [ngModelOptions]="{standalone: true}" (keypress)="utility.isNumberKey($event)">
                </p-inputNumber>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other3)">*</span></label>
                <input pInputText type="text" (keypress)="utility.isNumberKey($event)"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''"
                  [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" />
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                    *ngIf="checkRequired(field.name, vendor_other3)">*</span></label>
                <input [disabled]="isView" pInputText type="text" [(ngModel)]="field.value"
                  [ngModelOptions]="{standalone: true}"
                  [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </form>

  <p-footer>
    <span class="p-text-center" *ngIf="applyValidation" style="color: red;">Please fill data for all * fields.</span>
    <button type="button" pButton (click)="cancelVendorDialog()" label="Cancel" class="p-button-secondary"></button>
    <button *ngIf="!isView" type="button" pButton class="p-button-success" [disabled]="!vendorForm.valid || isDisabled"
      label="Save" (click)="save(vendorForm.getRawValue())"></button>
  </p-footer>
</p-dialog>

<p-dialog header="{{ addressHeader }}" [(visible)]="displayAddressAdd" [modal]="true" [responsive]="true"
  [closable]="false" [style]="{ width: '60vw' }" (onHide)="addressForm.reset()">
  <form [formGroup]="addressForm">
    <div class="header">
      <h5>
        Address Information
        <p-inputSwitch name="statusId" class="header-switch" formControlName="statusId"></p-inputSwitch>
      </h5>
    </div>
    <div class="card">
      <div class="p-field p-formgrid p-grid"
        *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[0]?.isChecked">
        <div class="p-col-12">
          <label>{{vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[0]?.labelname}}
            <span style="color: red">*</span></label>
          <p-dropdown [options]="addressTypes" formControlName="addressType" optionLabel="name"
            placeholder="Select Address Type" appendTo="body" (onChange)="getAddrType()">
          </p-dropdown>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[1]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_address &&
            vendorTemplate.labels_address[1]?.labelname}}</label>
        
          <lion-gm-place-autocomplete [formattedAddress]="addressInput" (onRemoveAddress)="removeAddressLocation()"
            (onAddressChange)="locationAddresChanged($event)">
          </lion-gm-place-autocomplete>
          <small class="p-invalid">{{ ErrorMessageSetLocation }}</small>
        </div>
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[0]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_address &&
            vendorTemplate.labels_address[2]?.labelname}}</label>
          <input pInputText type="text" formControlName="streetAddress2">
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[3]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_address &&
            vendorTemplate.labels_address[3]?.labelname}}</label>
          <p-dropdown appendTo="body" [options]="country" optionLabel="name" formControlName="countryId"
            placeholder="Select Country" [filter]="true" (onChange)="getStatesFromCountry($event.value)">
          </p-dropdown>
        </div>
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[4]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_address &&
            vendorTemplate.labels_address[4]?.labelname}}</label>
          <p-dropdown appendTo="body" [options]="states" placeholder="Select State" formControlName="stateId"
            [filter]="true" optionLabel="name" (onChange)="getCitiesFromState($event.value)">
          </p-dropdown>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6"
          *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[5]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_address &&
            vendorTemplate.labels_address[5]?.labelname}}</label>
          <p-dropdown appendTo="body" [options]="city" placeholder="Select City" formControlName="cityId"
            [filter]="true" optionLabel="name"></p-dropdown>
        </div>
        <div class="p-col-12 p-lg-3"
          *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[6]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_address &&
            vendorTemplate.labels_address[6]?.labelname}}</label>
          <input pInputText type="text" formControlName="zipCode">
        </div>
        <div class="p-col-12 p-lg-3"
          *ngIf="vendorTemplate && vendorTemplate.labels_address && vendorTemplate.labels_address[7]?.isChecked">
          <label>{{vendorTemplate && vendorTemplate.labels_address &&
            vendorTemplate.labels_address[7]?.labelname}}</label>
          <p-dropdown appendTo="body" placeholder="Select contact"
            [options]="!isAddVendor?savedVendor?.vendorContacts:[]" optionLabel="contact.firstName"
            formControlName="attentionId"></p-dropdown>
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" pButton (click)="deleteAddress()" label="Delete" class="p-button-danger"
      *ngIf="addressHeader==='Edit Address' && !addressForm.controls['isDefault'].value"></button>
    <button type="button" pButton (click)="displayAddressAdd = false" label="Cancel"
      class="p-button-secondary"></button>
    <button type="button" pButton class="p-button-success" [disabled]="!addressForm.valid"
      (click)="saveAddress(addressForm.value)" label="Save">
    </button>
  </p-footer>
</p-dialog>

<p-dialog header="Add New Address Type" [modal]="true" [(visible)]="displayAddAddressType" [style]="{width: '45vw'}"
  (onHide)="addressTypeForm.reset()">
  <form [formGroup]="addressTypeForm">
    <div class="card">
      <div class="p-grid">
        <div class="p-col-12">
          <label>Type Name</label>
          <input type="text" pInputText style="width: 100%;" name="addressType" formControlName="name">
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button pButton (click)="displayAddAddressType=false;" label="Cancel" class="p-button-secondary"></button>
    <button pButton label="Save" (click)="saveAddressType(addressTypeForm.value)"
      [disabled]="!addressTypeForm.valid"></button>
  </p-footer>
</p-dialog>
<p-toast position="top-right" [baseZIndex]="10000"></p-toast>